import { ComponentPropsWithoutRef } from "react";
import { FaRegSave } from "react-icons/fa";
import { Ripple } from 'primereact/ripple';
import { RxUpdate } from "react-icons/rx";
import { RiLoginCircleLine } from "react-icons/ri";
import { GrFormPreviousLink } from "react-icons/gr";
import { GrFormNextLink } from "react-icons/gr";
import { MdFormatListNumbered } from "react-icons/md";
import { IoSearchSharp, IoServerOutline } from "react-icons/io5";
import { TbEye } from "react-icons/tb";
import { IoMdAddCircleOutline } from "react-icons/io";
import { GoSearch } from "react-icons/go";
import { BsPrinter } from "react-icons/bs";

const buttonConfig = {
    save: {
        icon: <FaRegSave />,
        label: 'Save',
        bg_color: "bg-green-700",
        hover: "hover:bg-green-500"
    },
    all: {
        icon: <MdFormatListNumbered />,
        label: 'All',
        bg_color: "bg-green-700",
        hover: "hover:bg-green-500"
    },
    update: {
        icon: <RxUpdate />,
        label: 'Update',
        bg_color: "bg-cyan-700",
        hover: "hover:bg-cyan-500"
    },
    search: {
        icon: <IoSearchSharp />,
        label: 'Search',
        bg_color: "bg-cyan-700",
        hover: "hover:bg-cyan-500"
    },
    login: {
        icon: <RiLoginCircleLine />,
        label: 'Login',
        bg_color: "bg-green-700",
        hover: "hover:bg-green-500"
    },
    prev: {
        icon: <GrFormPreviousLink />,
        label: 'Prev',
        bg_color: "bg-gray-500",
        hover: "hover:bg-gray-600"
    },
    print: {
        icon: <BsPrinter />,
        label: 'Print',
        bg_color: "bg-gray-500",
        hover: "hover:bg-gray-600"
    },
    next: {
        icon: <GrFormNextLink />,
        label: 'Next',
        bg_color: "bg-gray-500",
        hover: "hover:bg-gray-600"
    },
    post: {
        icon: <IoServerOutline />,
        label: 'Post',
        bg_color: "bg-blue-500",
        hover: "hover:bg-blue-600"
    },
    list: {
        icon: <TbEye />,
        label: 'View',
        bg_color: "bg-orange-500",
        hover: "hover:bg-orange-600"
    },
    add: {
        icon: <IoMdAddCircleOutline />,
        label: 'Add',
        bg_color: "bg-indigo-500",
        hover: "hover:bg-indigo-600"
    },
};

type ButtonProps = {
    el: 'button',
    label_btn?: string,
    loading?: boolean;
    btn_type: keyof typeof buttonConfig,
} & ComponentPropsWithoutRef<'button'>;

export const Button = ({ btn_type, loading, ...props }: ButtonProps) => {
    const { icon, label, bg_color, hover } = buttonConfig[btn_type] || { icon: null, label: '', bg_color: '', hover: '' };
    return (
        <button
            className={`relative ${btn_type ==='login' && "w-full"} inline-flex items-center justify-center text-white rounded-md text-[12px] font-semibold ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-0 disabled:opacity-50 whitespace-nowrap disabled:pointer-events-none ${bg_color} ${hover} ${btn_type==="prev"||"next"?"py-[3.5px]":"py-[5px]" } px-4 py-[5px]`}
            {...props}
        >
            <Ripple />
            <div className="flex items-center gap-1">
                {icon}
                <span>{loading? "Submitted..":props.label_btn?props.label_btn:label}</span>
            </div>
        </button>
    );
};
